"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textLinkStyles = exports.inlineLinkStyles = exports["default"] = void 0;
var _styledComponents = require("styled-components");
var _focus = require("./focus");
var _theme = _interopRequireDefault(require("../theme"));
var _typographyHelper = require("../utils/typographyHelper");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var inlineLinkStyles = exports.inlineLinkStyles = (0, _styledComponents.css)(["font-size:inherit;font-weight:600;text-decoration:underline;&:active,&:focus{", ";border-radius:1px;}&:hover{color:", ";}color:", ";"], _focus.focusOutlineStyle, function (_ref) {
  var color = _ref.color;
  return color === 'white' ? 'white' : _theme["default"].indigo80;
}, function (_ref2) {
  var color = _ref2.color;
  return color === 'white' ? 'white' : _theme["default"].indigo60;
});
var textLinkStyles = exports.textLinkStyles = inlineLinkStyles;
var anchorStyles = (0, _styledComponents.css)(["color:", ";font-family:", ";font-size:", ";cursor:pointer;text-decoration:none;outline:none;font-weight:700;&:hover{color:", ";text-decoration:underline;}&:active,&:focus{", ";border-radius:1px;}"], function (_ref3) {
  var color = _ref3.color;
  return color === 'white' ? 'white' : _theme["default"].indigo60;
}, _theme["default"].buenosAires, (0, _typographyHelper.pxToRem)(16), function (_ref4) {
  var color = _ref4.color;
  return color === 'white' ? 'white' : _theme["default"].indigo80;
}, _focus.focusOutlineStyle);
var _default = exports["default"] = anchorStyles;